const DEFAULT_TOP_NAV = ["Movies", "TV Shows", "Sports", "More"];

export { DEFAULT_TOP_NAV };
